// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactImprint_wrapper__GN+7i","container":"ContactImprint_container__WQwK-","mailLink":"ContactImprint_mailLink__AmhZT","contacts":"ContactImprint_contacts__GoCHK"};